import { FC, useContext } from "react";

import { FooterContext } from "src/context/footerContext";

import { FAX_NUMBER, PHONE_NUMBER } from "../../constants/contact";
import { ContactAndSafetyInfoProps } from "./types";

const ContactAndSafetyInfo: FC<ContactAndSafetyInfoProps> = ({ alignText, textColor, isLogin = false }): JSX.Element => {
  const {changeAccordianVisibility} =  useContext(FooterContext)

  return (
    <>
      <div className={`${alignText} mb-3`}>
      <a
        type="button"
        onClick={changeAccordianVisibility}
        className=""
      >
        Important Safety Information
      </a>
      <span className={`text-${textColor}`}> | </span>
      <a
        href="http://www.bioventusglobal.com/"
        target="_blank"
        rel="noreferrer"
        className=""
      >
        Full Prescribing Information
      </a>
    </div>

    <div className={`${alignText} mb-3`} data-tour="sixth-step">
      <p className={`text-${textColor} mb-0`}>
        Phone: {PHONE_NUMBER}
      </p>
      <p className={`text-${textColor}`}>
        Fax: {FAX_NUMBER}
      </p>
    </div>
    </>
  );
};

export default ContactAndSafetyInfo;
